
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-complaints",
      function () {
        return require("private-next-pages/customer-complaints.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-complaints"])
      });
    }
  